import React from 'react'
import DisplaySkill from './DisplaySkill'

function DisplaySkillWindow(props) {
	return (
		<div>
			{props.treeView.map((col, index) =>
				index <= props.treeViewLimit ? (
					<div className={'row' + index} key={'row' + index}>
						{col.map((row, skindex) => (
							<DisplaySkill
								skindex={skindex}
								skill={row}
								key={skindex + row.AegisName}
								change={row.changeLevel}
							/>
						))}
					</div>
				) : null
			)}
		</div>
	)
}

export default DisplaySkillWindow
